export default __webpack_public_path__ + "static/media/operatory_3.0e510f38.png";